/**
 * SALUS 2.0 Scent Discovery UI — Discover Scents MODAL presentation.
 * Unpublished theme 189586211094 only. Does not edit Keystone set 17130.
 * Write path (on Confirm only): setValue(KS_SCENT[slot]) + setValue(KS_STRENGTH[slot]).
 * PDP simplify: Choose/Edit slot UI; hide Keystone scent/strength chrome (presentation only).
 * Select opens in-modal strength step; Edit lands on strength; Close/Back/Escape discard pending.
 * Fallback: forceShowKeystoneChrome / __SALUS_SD_FORCE_FALLBACK__ strips Choose/Edit (no dual path).
 * Storefront Customize ATC guard: incomplete active slots block product-form / sticky ATC submit.
 */
(function () {
  'use strict';

  var PRODUCT_HINT = '10719670272278';
  var KS_SCENT = { 1: 29271, 2: 29278, 3: 29273, 4: 29274, 5: 29275 };
  var KS_STRENGTH = { 1: 29272, 2: 29276, 3: 29277, 4: 29279, 5: 29280 };
  var KS_ADD = { 2: 29284, 3: 29281, 4: 29282, 5: 29283 };
  var KS_ADD_ON_VALUE = {
    2: 'Do You Want to Add Another Scent?',
    3: 'Do You Want to Add a Third Scent?',
    4: 'Do You Want to Add a Fourth Scent?',
    5: 'Do You Want to Add a Fifth Scent?'
  };
  var KS_SCENTING = 29270;
  var PAGE_SIZE = 6; /* retained for export compat; UI uses continuous list 2026-09-08 */
  var ORDINAL = { 1: 'first', 2: 'second', 3: 'third', 4: 'fourth', 5: 'fifth' };
  var ORDINAL_TITLE = { 1: 'First', 2: 'Second', 3: 'Third', 4: 'Fourth', 5: 'Fifth' };
  var STRENGTH_OPTIONS = [
    'LIGHT — Subtle',
    'REGULAR — Normal',
    'HEAVY — Stronger'
  ];
  var STRENGTH_DEFAULT = 'REGULAR — Normal';
  var BTN_ATTR = 'data-salus-sd-trigger';
  var WRAP_ATTR = 'data-salus-sd-trigger-wrap';
  var SLOT_UI_ATTR = 'data-salus-sd-slot-ui';
  var EDIT_ATTR = 'data-salus-sd-edit';
  var KS_CHROME_HIDE = 'salus-sd-ks-chrome-hidden';

  var state = {
    catalog: null,
    activeSlot: 1,
    category: 'all',
    query: '',
    page: 1,
    root: null,
    modal: null,
    lastFocus: null,
    triggerBtn: null,
    observer: null,
    open: false,
    detailOpen: false,
    strengthOpen: false,
    pendingScent: null,
    pendingStrength: STRENGTH_DEFAULT,
    _strengthOrigin: 'results',
    _applying: false,
    _lastFiltered: null,
    _lastValid: null,
    _bodyOverflow: '',
    _savedScrollTop: 0,
    _learnMoreBtn: null,
    _learnMoreHandle: '',
    _detailHandle: '',
    _layoutObs: null,
    _chromeHidden: false,
    _enhancedReady: false,
    _validationBound: false,
    _atcGuardBound: false,
    _fetchGuarded: false,
    _fallbackLive: null
  };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getKO() { return window.KeyOptions || null; }

  function getInstance() {
    var KO = getKO();
    if (!KO || typeof KO.getInstance !== 'function') return null;
    var pid = (state.root && state.root.getAttribute('data-product-id')) || PRODUCT_HINT;
    try {
      return (
        KO.getInstance({ productId: String(pid) }) ||
        KO.getInstance(String(pid)) ||
        KO.getInstance() ||
        null
      );
    } catch (e) {
      return null;
    }
  }

  function setValue(optionId, value) {
    var inst = getInstance();
    if (!inst || typeof inst.setValue !== 'function') return false;
    try { return !!inst.setValue(optionId, value); } catch (e) { return false; }
  }

  function getValue(optionId) {
    var inst = getInstance();
    if (!inst || typeof inst.getValue !== 'function') return undefined;
    try { return inst.getValue(optionId); } catch (e) { return undefined; }
  }

  function refreshProperties() {
    var inst = getInstance();
    var KO = getKO();
    try {
      if (inst && typeof inst.refreshProperties === 'function') {
        var p = inst.refreshProperties();
        if (p && typeof p.then === 'function') return p.catch(function () {});
      }
    } catch (e) {}
    try {
      if (KO && typeof KO.refreshProperties === 'function') KO.refreshProperties();
    } catch (e2) {}
    return null;
  }

  function usable(v) {
    if (v == null || v === false) return '';
    if (Array.isArray(v)) {
      if (!v.length) return '';
      v = v[0];
    }
    if (typeof v === 'boolean') return v ? '1' : '';
    var s = String(v).trim();
    if (!s) return '';
    if (/^choose|^select|^--/i.test(s)) return '';
    return s;
  }

  function isCustomize() {
    var v = usable(getValue(KS_SCENTING));
    if (v) return /customize/i.test(v) && !/natural|no scent|unscented/i.test(v);
    var KO = getKO();
    if (KO && typeof KO.getCurrentOptions === 'function') {
      try {
        var cur = KO.getCurrentOptions();
        var sels = (cur && cur.selections) || [];
        for (var i = 0; i < sels.length; i++) {
          if (Number(sels[i].optionId) === KS_SCENTING) {
            return /customize/i.test(String(sels[i].value || ''));
          }
        }
      } catch (e) {}
    }
    var block = document.getElementById('key_options_block');
    if (block) {
      var nodes = block.querySelectorAll('select, input[type="radio"], input[type="checkbox"]');
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        var idish = ((el.name || '') + ' ' + (el.id || '') + ' ' + (el.getAttribute('data-option-id') || ''));
        if (idish.indexOf(String(KS_SCENTING)) === -1) continue;
        var val = el.tagName === 'SELECT' ? el.value : (el.checked ? el.value : '');
        if (/customize/i.test(String(val || ''))) return true;
        if (/natural|no scent|unscented/i.test(String(val || ''))) return false;
      }
    }
    return false;
  }

  function isCheckedAdd(slot) {
    var v = getValue(KS_ADD[slot]);
    if (v === true) return true;
    if (v === false || v == null) return false;
    if (Array.isArray(v)) return v.length > 0;
    var s = usable(v);
    if (!s) return false;
    return s === KS_ADD_ON_VALUE[slot] || /add (another|a third|a fourth|a fifth) scent/i.test(s);
  }

  function availableSlots() {
    var slots = [1];
    if (!isCustomize()) return slots;
    for (var slot = 2; slot <= 5; slot++) {
      if (isCheckedAdd(slot)) slots.push(slot);
      else break;
    }
    return slots;
  }

  function matchesOptionControl(el, optionId) {
    var idish = ((el.name || '') + ' ' + (el.id || '') + ' ' + (el.getAttribute('data-option-id') || '')).toLowerCase();
    var sid = String(optionId);
    if (idish.indexOf(sid) !== -1) return true;
    if (el.id && el.id.indexOf('select_dd_' + sid) !== -1) return true;
    return false;
  }

  function isPlaceholderOption(text) {
    var s = String(text || '').trim();
    if (!s) return true;
    if (/^choose|^select|^please select|^--/i.test(s)) return true;
    return false;
  }

  function getValidKeystoneValues(slot) {
    var optionId = KS_SCENT[slot];
    var out = [];
    var seen = Object.create(null);
    function add(v) {
      var s = String(v == null ? '' : v).trim();
      if (!s || isPlaceholderOption(s) || seen[s]) return;
      seen[s] = true;
      out.push(s);
    }

    var block = document.getElementById('key_options_block');
    if (block && optionId) {
      var selects = block.querySelectorAll('select');
      for (var i = 0; i < selects.length; i++) {
        var sel = selects[i];
        if (!matchesOptionControl(sel, optionId)) continue;
        for (var o = 0; o < sel.options.length; o++) {
          add(sel.options[o].value || sel.options[o].text);
        }
      }
      var radios = block.querySelectorAll('input[type="radio"]');
      for (var r = 0; r < radios.length; r++) {
        var rad = radios[r];
        if (!matchesOptionControl(rad, optionId)) continue;
        add(rad.value);
      }
    }

    try {
      var inst = getInstance();
      var KO = getKO();
      var candidates = [];
      if (inst) {
        if (typeof inst.getOption === 'function') candidates.push(inst.getOption(optionId));
        if (typeof inst.getOptionById === 'function') candidates.push(inst.getOptionById(optionId));
        if (inst.options && typeof inst.options === 'object') {
          candidates.push(inst.options[optionId] || inst.options[String(optionId)]);
        }
      }
      if (KO && typeof KO.getOption === 'function') candidates.push(KO.getOption(optionId));
      for (var c = 0; c < candidates.length; c++) {
        var opt = candidates[c];
        if (!opt) continue;
        var values = opt.options_values || opt.values || opt.choices || opt.options || null;
        if (!values) continue;
        if (Array.isArray(values)) {
          for (var vi = 0; vi < values.length; vi++) {
            var item = values[vi];
            if (item == null) continue;
            if (typeof item === 'string' || typeof item === 'number') add(item);
            else add(item.value || item.label || item.name || item.text);
          }
        }
      }
    } catch (e) {}

    return out;
  }

  function intersectCatalogForSlot(slot) {
    var valid = getValidKeystoneValues(slot);
    var validSet = Object.create(null);
    for (var i = 0; i < valid.length; i++) validSet[valid[i]] = true;
    var scents = (state.catalog && state.catalog.scents) || [];
    var out = [];
    for (var s = 0; s < scents.length; s++) {
      var scent = scents[s];
      if (!scent || scent.status !== 'active') continue;
      var kv = scent.keystone_value == null ? '' : String(scent.keystone_value);
      if (!kv) continue;
      if (valid.length && !validSet[kv]) continue;
      out.push(scent);
    }
    return { scents: out, validCount: valid.length, valid: valid };
  }

  function filterScents(scents) {
    var q = String(state.query || '').trim().toLowerCase();
    var cat = state.category || 'all';
    var out = [];
    for (var i = 0; i < scents.length; i++) {
      var s = scents[i];
      if (cat && cat !== 'all') {
        var handles = s.category_handles || [];
        var hit = false;
        for (var h = 0; h < handles.length; h++) {
          if (String(handles[h]) === cat) { hit = true; break; }
        }
        if (!hit) continue;
      }
      if (q) {
        var hay = [s.display_name, s.short_copy, s.description];
        var kws = s.search_keywords || [];
        for (var k = 0; k < kws.length; k++) hay.push(kws[k]);
        var blob = hay.map(function (x) { return String(x == null ? '' : x); }).join(' ').toLowerCase();
        if (blob.indexOf(q) === -1) continue;
      }
      out.push(s);
    }
    return out;
  }

  function categoryTitle(handle) {
    var cats = (state.catalog && state.catalog.categories) || [];
    for (var i = 0; i < cats.length; i++) {
      var c = cats[i];
      var h = c.category_handle || c.handle;
      if (h === handle) return c.title || handle;
    }
    return handle;
  }

  function slotHeading(slot) {
    var ord = ORDINAL[slot] || String(slot);
    return 'Choose your ' + ord + ' scent';
  }

  function scentInitials(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }

  function emptyMediaHtml(name, kind) {
    var cls = kind === 'detail' ? 'salus-sd__detail-media salus-sd__detail-media--empty' : 'salus-sd__card-media salus-sd__card-media--empty';
    var label = String(name || 'Scent').trim() || 'Scent';
    return (
      '<div class="' + cls + '" role="img" aria-label="' + escapeHtml(label) + '">' +
      '<span class="salus-sd__card-fallback-initials">' + escapeHtml(scentInitials(label)) + '</span>' +
      '<span class="salus-sd__card-fallback-name">' + escapeHtml(label) + '</span>' +
      '</div>'
    );
  }

  /**
   * Display-only parse of Metaobject description.
   * Preserve facts; collapse confidently identified catalog boilerplate.
   */
  function parseDescription(raw) {
    var text = String(raw == null ? '' : raw).replace(/\r\n/g, '\n').trim();
    if (!text) return { empty: true };

    var BOILER_RE = /(?:^|\s)(ABOUT\s+OUR\s+SCENTS|HOW\s+TO\s+USE|WHY\s+CUSTOMERS\s+LOVE\s+THEM|ABOUT\s+SALUS\s+FRAGRANCE|FRAGRANCE\s+OIL\s+CARE)\b/i;

    // Split confidently identified catalog boilerplate (inline or lined)
    var working = text;
    var extra = '';
    var bm = BOILER_RE.exec(text);
    if (bm && typeof bm.index === 'number') {
      // Prefer ABOUT OUR SCENTS as primary split when present
      var about = text.search(/ABOUT\s+OUR\s+SCENTS/i);
      var splitAt = about >= 0 ? about : bm.index;
      // Include leading whitespace in extra only after trim of working
      working = text.slice(0, splitAt).trim();
      extra = text.slice(splitAt).trim();
    }

    var narrative = working;
    var notes = [];

    // Notes may be line-based OR inline in one paragraph
    var noteRe = /(?:^|\s)(Top\s+Notes?|Middle\s+Notes?|Heart\s+Notes?|Base\s+Notes?)\s*[:\-–]\s*/gi;
    var noteStarts = [];
    var nm;
    while ((nm = noteRe.exec(working)) !== null) {
      var labelRaw = nm[1];
      var matchStart = nm.index;
      // Skip leading whitespace in index for content slice math
      var absStart = matchStart;
      var leadingWs = /^\s/.test(nm[0]) ? 1 : 0;
      noteStarts.push({
        index: absStart + leadingWs,
        label: labelRaw,
        valueStart: absStart + nm[0].length
      });
    }

    if (noteStarts.length) {
      narrative = working.slice(0, noteStarts[0].index).trim();
      for (var ni = 0; ni < noteStarts.length; ni++) {
        var vStart = noteStarts[ni].valueStart;
        var vEnd = ni + 1 < noteStarts.length ? noteStarts[ni + 1].index : working.length;
        var val = working.slice(vStart, vEnd).trim();
        var label = noteStarts[ni].label;
        if (/^top/i.test(label)) label = 'Top notes';
        else if (/^middle|^heart/i.test(label)) label = 'Middle notes';
        else if (/^base/i.test(label)) label = 'Base notes';
        if (val) notes.push({ label: label, value: val });
      }
    }

    narrative = narrative
      .replace(/^\s*SCENT\s+DESCRIPTION\s*:?\s*/i, '')
      .replace(/^\s*DESCRIPTION\s*:?\s*/i, '')
      .trim();

    // Drop leading product title line / "X Fragrance Oil" prefix when followed by narrative
    narrative = narrative.replace(/^[^\n.]{0,80}\bFragrance Oil\b\s*/i, '').trim();
    narrative = narrative.replace(/^\s*SCENT\s+DESCRIPTION\s*:?\s*/i, '').trim();

    var lines = narrative.split(/\n/);
    if (lines.length > 1 && lines[0].trim().length < 60 && !/[.!?]$/.test(lines[0].trim())) {
      var rest = lines.slice(1).join('\n').replace(/^\s*SCENT\s+DESCRIPTION\s*:?\s*/i, '').trim();
      if (rest.length > 20) narrative = rest;
    }

    if (!narrative && !notes.length) {
      return { empty: false, ambiguous: true, full: text, narrative: '', notes: [], extra: '' };
    }

    return {
      empty: false,
      ambiguous: false,
      narrative: narrative,
      notes: notes,
      extra: extra,
      full: text
    };
  }

  function renderParsedDescription(parsed) {
    if (!parsed || parsed.empty) {
      return '<p class="salus-sd__detail-desc salus-sd__detail-desc--muted">Description unavailable</p>';
    }
    if (parsed.ambiguous && parsed.full) {
      return '<p class="salus-sd__detail-desc">' + escapeHtml(parsed.full) + '</p>';
    }
    var html = '';
    if (parsed.narrative) {
      html += '<p class="salus-sd__detail-desc">' + escapeHtml(parsed.narrative) + '</p>';
    }
    if (parsed.notes && parsed.notes.length) {
      html += '<div class="salus-sd__detail-notes"><div class="salus-sd__detail-notes-title">Scent notes</div><dl>';
      for (var i = 0; i < parsed.notes.length; i++) {
        html +=
          '<dt>' + escapeHtml(parsed.notes[i].label) + '</dt>' +
          '<dd>' + escapeHtml(parsed.notes[i].value) + '</dd>';
      }
      html += '</dl></div>';
    }
    if (parsed.extra) {
      html +=
        '<details class="salus-sd__detail-extra">' +
        '<summary>Additional information</summary>' +
        '<div class="salus-sd__detail-extra-body">' + escapeHtml(parsed.extra) + '</div>' +
        '</details>';
    }
    if (!html) {
      return '<p class="salus-sd__detail-desc salus-sd__detail-desc--muted">Description unavailable</p>';
    }
    return html;
  }

  function positionLabel(slot) {
    var title = ORDINAL_TITLE[slot] || String(slot);
    return 'Your ' + title + ' Scent';
  }

  function isValidStrength(v) {
    return STRENGTH_OPTIONS.indexOf(String(v || '')) !== -1;
  }

  function currentSlotStrength(slot) {
    var raw = usable(getValue(KS_STRENGTH[slot]));
    if (raw && isValidStrength(raw)) return raw;
    return '';
  }

  function strengthShortLabel(full) {
    var s = String(full || '');
    if (/^LIGHT\b/i.test(s)) return 'Light';
    if (/^REGULAR\b/i.test(s)) return 'Regular';
    if (/^HEAVY\b/i.test(s)) return 'Heavy';
    return s;
  }

  function currentSlotScentValue(slot) {
    return usable(getValue(KS_SCENT[slot]));
  }

  function findScentByKeystoneValue(value) {
    var v = String(value == null ? '' : value).trim();
    if (!v) return null;
    var scents = (state.catalog && state.catalog.scents) || [];
    for (var i = 0; i < scents.length; i++) {
      if (String(scents[i].keystone_value || '').trim() === v) return scents[i];
    }
    return null;
  }

  function findKeyOptionWrap(el) {
    return el && el.closest ? el.closest('.key_option') : null;
  }

  function findStrengthRadios(slot) {
    var optionId = KS_STRENGTH[slot];
    if (!optionId) return [];
    var block = document.getElementById('key_options_block');
    if (!block) return [];
    var out = [];
    var radios = block.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (matchesOptionControl(radios[i], optionId)) out.push(radios[i]);
    }
    return out;
  }

  function chooseButtonLabel(slot) {
    var title = ORDINAL_TITLE[slot] || String(slot);
    return 'Choose Your ' + title + ' Scent';
  }

  function discardPending() {
    state.pendingScent = null;
    state.pendingStrength = STRENGTH_DEFAULT;
    state._applying = false;
  }

  function shouldForceFallback() {
    try {
      return window.__SALUS_SD_FORCE_FALLBACK__ === true;
    } catch (e) {
      return false;
    }
  }

  function isVisibleControl(el) {
    if (!el || !el.getBoundingClientRect) return false;
    if (el.hidden || el.getAttribute('aria-hidden') === 'true') return false;
    if (el.disabled) return false;
    var style = window.getComputedStyle(el);
    if (!style || style.display === 'none' || style.visibility === 'hidden') return false;
    if (el.closest && el.closest('.' + KS_CHROME_HIDE)) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function removeAllSlotUis(block) {
    block = block || document.getElementById('key_options_block');
    if (!block) return;
    $all('[' + SLOT_UI_ATTR + ']', block).forEach(function (ui) {
      if (ui.parentNode) ui.parentNode.removeChild(ui);
    });
  }

  function ensureFallbackLiveRegion() {
    if (state._fallbackLive && state._fallbackLive.isConnected) return state._fallbackLive;
    var el = document.getElementById('salus-sd-fallback-live');
    if (!el) {
      el = document.createElement('div');
      el.id = 'salus-sd-fallback-live';
      el.className = 'salus-sd__fallback-live';
      el.setAttribute('role', 'alert');
      el.setAttribute('aria-live', 'assertive');
      el.hidden = true;
      var block = document.getElementById('key_options_block');
      if (block && block.parentNode) block.parentNode.insertBefore(el, block);
      else document.body.appendChild(el);
    }
    state._fallbackLive = el;
    return el;
  }

  function clearFallbackLive() {
    var el = ensureFallbackLiveRegion();
    el.hidden = true;
    el.textContent = '';
  }

  function announceFallbackError(msg) {
    var el = ensureFallbackLiveRegion();
    el.hidden = !msg;
    el.textContent = msg || '';
  }

  function focusFallbackControl(slot) {
    slot = Number(slot) || 1;
    var sel = findScentSelect(slot);
    if (sel && isVisibleControl(sel)) {
      try { sel.focus(); return sel; } catch (e) {}
    }
    var radios = findStrengthRadios(slot);
    for (var i = 0; i < radios.length; i++) {
      if (isVisibleControl(radios[i])) {
        try { radios[i].focus(); return radios[i]; } catch (e2) {}
      }
    }
    var block = document.getElementById('key_options_block');
    if (block) {
      var scenting = block.querySelectorAll('input[type="radio"], select');
      for (var j = 0; j < scenting.length; j++) {
        var el = scenting[j];
        if (!matchesOptionControl(el, KS_SCENTING)) continue;
        if (!isVisibleControl(el)) continue;
        try { el.focus(); return el; } catch (e3) {}
      }
      var any = block.querySelectorAll('select, input[type="radio"]');
      for (var k = 0; k < any.length; k++) {
        if (!isVisibleControl(any[k])) continue;
        try { any[k].focus(); return any[k]; } catch (e4) {}
      }
    }
    return null;
  }

  function forceCloseDiscovery() {
    if (!state.modal) {
      discardPending();
      unlockBodyScroll();
      return;
    }
    state._applying = false;
    if (state.strengthOpen) {
      state.strengthOpen = false;
      discardPending();
      var strength = strengthPanel();
      if (strength) strength.hidden = true;
      showStrengthError('');
      setConfirmBusy(false);
    } else {
      discardPending();
    }
    if (state.detailOpen) {
      state.detailOpen = false;
      state._detailHandle = '';
      state._learnMoreBtn = null;
      var results = resultsView();
      var panel = detailPanel();
      if (panel) panel.hidden = true;
      if (results) results.hidden = false;
      state.modal.removeAttribute('data-detail-handle');
    }
    state.open = false;
    state.modal.hidden = true;
    document.removeEventListener('keydown', onKeydown, true);
    unlockBodyScroll();
    state.triggerBtn = null;
    state.lastFocus = null;
  }

  function enterFallbackMode(opts) {
    opts = opts || {};
    state._enhancedReady = false;
    forceCloseDiscovery();
    var block = document.getElementById('key_options_block');
    removeAllSlotUis(block);
    if (block) removeLegacyTriggers(block);
    restoreKeystoneChrome();
    clearFallbackLive();
    if (opts.focus !== false) {
      focusFallbackControl(opts.slot || 1);
    }
  }

  function remountEnhancedMode() {
    if (shouldForceFallback()) {
      enterFallbackMode({ focus: false });
      return false;
    }
    if (!state.catalog) {
      enterFallbackMode({ focus: false });
      return false;
    }
    state._enhancedReady = true;
    clearFallbackLive();
    ensureModal();
    bindValidationRedirect();
    bindAtcGuard();
    injectSlotControls();
    return true;
  }

  function slotIsComplete(slot) {
    return !!(currentSlotScentValue(slot) && currentSlotStrength(slot));
  }

  function validateCustomizeForAtc() {
    if (!document.getElementById('key_options_block')) return { ok: true };
    if (!isCustomize()) return { ok: true };
    var avail = availableSlots();
    var incomplete = [];
    var i;
    for (i = 0; i < avail.length; i++) {
      if (!slotIsComplete(avail[i])) incomplete.push(avail[i]);
    }
    if (!incomplete.length) return { ok: true };
    return {
      ok: false,
      slots: incomplete,
      first: incomplete[0],
      message: 'Please choose a scent and strength for this position.'
    };
  }

  function focusAtcValidationTarget(slot, msg) {
    msg = msg || 'Please choose a scent and strength for this position.';
    if (state._enhancedReady) {
      showSlotValidation(slot, msg);
      return;
    }
    announceFallbackError(msg);
    focusFallbackControl(slot);
  }

  function blockInvalidAtc(e) {
    var check;
    try { check = validateCustomizeForAtc(); } catch (err0) { return false; }
    if (!check || check.ok) return false;
    try { e.preventDefault(); } catch (err) {}
    try { e.stopPropagation(); } catch (err2) {}
    try {
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    } catch (err3) {}
    try { focusAtcValidationTarget(check.first, check.message); } catch (err4) {}
    return true;
  }

  function isProductAtcSubmitter(el) {
    if (!el || !el.closest) return false;
    var btn = el.closest('button, [data-add-to-cart], input[type="submit"], [role="button"]');
    if (!btn) return false;
    if (btn.name === 'checkout') return false;
    var label = String((btn.textContent || btn.value || '') + ' ' + (btn.getAttribute('aria-label') || ''));
    var looksAtc = btn.hasAttribute('data-add-to-cart') ||
      btn.name === 'add' ||
      /add to (bag|cart)/i.test(label);
    if (!looksAtc) return false;
    var formId = (btn.getAttribute && btn.getAttribute('form')) || '';
    var form = btn.form || (formId ? document.getElementById(formId) : null) || btn.closest('form') || document.getElementById('product-form');
    if (form && form.id === 'product-form') return true;
    if (formId === 'product-form') return true;
    if (btn.closest && btn.closest('[data-sticky-atc], .pdp-sticky')) return true;
    if (btn.hasAttribute('data-add-to-cart')) return true;
    return false;
  }

  function onAtcClickCapture(e) {
    if (!isProductAtcSubmitter(e.target)) return;
    blockInvalidAtc(e);
  }

  function onAtcSubmitCapture(e) {
    var form = e.target;
    if (!form || !isProductCartForm(form)) return;
    // Allow explicit checkout submitters
    if (e.submitter && e.submitter.name === 'checkout') return;
    blockInvalidAtc(e);
  }

  function onAtcFetchGuard(input, init) {
    var url = '';
    try {
      url = typeof input === 'string' ? input : (input && input.url) || '';
    } catch (e) { url = ''; }
    if (!/\/cart\/add(\.js)?(\?|$)/i.test(String(url))) return null;
    var check;
    try { check = validateCustomizeForAtc(); } catch (err) { return null; }
    if (!check || check.ok) return null;
    try { focusAtcValidationTarget(check.first, check.message); } catch (e2) {}
    var body = JSON.stringify({
      status: 422,
      message: check.message,
      description: check.message
    });
    return Promise.resolve(new Response(body, {
      status: 422,
      statusText: 'Unprocessable Entity',
      headers: { 'Content-Type': 'application/json' }
    }));
  }

  function blockInvalidAtcSilent() {
    var check;
    try { check = validateCustomizeForAtc(); } catch (err0) { return false; }
    if (!check || check.ok) return false;
    try { focusAtcValidationTarget(check.first, check.message); } catch (err4) {}
    return true;
  }

  function isProductCartForm(form) {
    if (!form || !form.getAttribute) return false;
    if (form.id === 'product-form') return true;
    var action = String(form.getAttribute('action') || '');
    if (/\/cart\/add/i.test(action) && form.classList && form.classList.contains('pdp__form')) return true;
    return false;
  }

  function onProductFormOnSubmit(e) {
    if (blockInvalidAtcSilent()) {
      try { e.preventDefault(); } catch (err) {}
      return false;
    }
    return true;
  }

  function guardProductFormSubmitMethods(form) {
    if (!form || !isProductCartForm(form)) return;
    form.setAttribute('data-salus-sd-submit-guarded', '1');
    form.onsubmit = onProductFormOnSubmit;
    form.submit = function () {
      if (blockInvalidAtcSilent()) return;
      return state._origProtoSubmit
        ? state._origProtoSubmit.call(form)
        : HTMLFormElement.prototype.submit.call(form);
    };
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit = function (submitter) {
        if (blockInvalidAtcSilent()) return;
        var rs = state._origProtoRequestSubmit || HTMLFormElement.prototype.requestSubmit;
        if (arguments.length) return rs.call(form, submitter);
        return rs.call(form);
      };
    }
  }

  function bindProductFormSubmitGuard() {
    var form = document.getElementById('product-form') ||
      document.querySelector('form.pdp__form[action*="/cart/add"]') ||
      document.querySelector('form[action="/cart/add"]');
    if (form) guardProductFormSubmitMethods(form);

    if (!state._protoSubmitGuarded && typeof HTMLFormElement !== 'undefined') {
      state._protoSubmitGuarded = true;
      state._origProtoSubmit = HTMLFormElement.prototype.submit;
      state._origProtoRequestSubmit = HTMLFormElement.prototype.requestSubmit;
      HTMLFormElement.prototype.submit = function () {
        if (isProductCartForm(this) && blockInvalidAtcSilent()) return;
        return state._origProtoSubmit.apply(this, arguments);
      };
      if (typeof HTMLFormElement.prototype.requestSubmit === 'function') {
        HTMLFormElement.prototype.requestSubmit = function (submitter) {
          if (isProductCartForm(this) && blockInvalidAtcSilent()) return;
          if (arguments.length) return state._origProtoRequestSubmit.apply(this, arguments);
          return state._origProtoRequestSubmit.apply(this, arguments);
        };
      }
    }

    if (!state._formGuardObserver && typeof MutationObserver !== 'undefined') {
      state._formGuardObserver = true;
      var obs = new MutationObserver(function () {
        var f = document.getElementById('product-form');
        if (f && f.getAttribute('data-salus-sd-submit-guarded') !== '1') {
          guardProductFormSubmitMethods(f);
        }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  function bindAtcGuard() {
    if (state._atcGuardBound) return;
    state._atcGuardBound = true;
    document.addEventListener('click', onAtcClickCapture, true);
    document.addEventListener('submit', onAtcSubmitCapture, true);
    bindProductFormSubmitGuard();
    // Theme ajax add uses fetch('/cart/add.js') after submit — guard that path too (storefront-only).
    if (!state._fetchGuarded && typeof window.fetch === 'function') {
      state._fetchGuarded = true;
      var origFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var blocked = onAtcFetchGuard(input, init);
        if (blocked) return blocked;
        return origFetch(input, init);
      };
    }
  }

  function strengthPanel() {
    return state.modal && state.modal.querySelector('[data-salus-sd-strength-panel]');
  }

  function validatePendingChoice(scent, slot) {
    if (!scent) return { ok: false, error: 'missing_scent' };
    if (!isCustomize()) return { ok: false, error: 'natural_selected' };
    slot = Number(slot) || Number(state.activeSlot) || 1;
    if (slot < 1 || slot > 5) return { ok: false, error: 'invalid_slot' };
    var avail = availableSlots();
    if (avail.indexOf(slot) === -1) return { ok: false, error: 'slot_unavailable' };
    var optionId = KS_SCENT[slot];
    var value = scent.keystone_value;
    if (!optionId || value == null || value === '') return { ok: false, error: 'missing_mapping' };
    var valid = getValidKeystoneValues(slot);
    if (valid.length && valid.indexOf(String(value)) === -1) {
      return { ok: false, error: 'not_keystone_valid' };
    }
    return { ok: true, slot: slot, optionId: optionId, value: String(value) };
  }

  function showStrengthError(msg) {
    if (!state.modal) return;
    var el = state.modal.querySelector('[data-salus-sd-strength-error]');
    if (!el) return;
    if (msg) {
      el.hidden = false;
      el.textContent = msg;
    } else {
      el.hidden = true;
      el.textContent = '';
    }
  }

  function setConfirmBusy(busy) {
    if (!state.modal) return;
    var btn = state.modal.querySelector('[data-salus-sd-strength-confirm]');
    if (!btn) return;
    btn.disabled = !!busy;
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    btn.textContent = busy ? 'Applying…' : 'Confirm scent & strength';
  }

  function renderStrengthChoices() {
    if (!state.modal) return;
    var group = state.modal.querySelector('[data-salus-sd-strength-group]');
    if (!group) return;
    var selected = state.pendingStrength || STRENGTH_DEFAULT;
    if (!isValidStrength(selected)) selected = STRENGTH_DEFAULT;
    state.pendingStrength = selected;
    group.innerHTML = STRENGTH_OPTIONS.map(function (opt, idx) {
      var id = 'salus-sd-strength-' + idx;
      var checked = opt === selected;
      return (
        '<label class="salus-sd__strength-option' + (checked ? ' is-selected' : '') + '" for="' + id + '">' +
        '<input type="radio" name="salus-sd-strength" id="' + id + '" value="' + escapeHtml(opt) + '"' +
        (checked ? ' checked' : '') + '>' +
        '<span class="salus-sd__strength-option-text">' + escapeHtml(opt) + '</span>' +
        '</label>'
      );
    }).join('');
    $all('input[name="salus-sd-strength"]', group).forEach(function (input) {
      input.addEventListener('change', function () {
        if (state._applying) return;
        if (isValidStrength(input.value)) {
          state.pendingStrength = input.value;
          renderStrengthChoices();
          showStrengthError('');
        }
      });
    });
  }

  function openStrengthView(scent, origin) {
    if (!scent || !state.modal) return { ok: false, error: 'missing_scent' };
    var check = validatePendingChoice(scent, state.activeSlot);
    if (!check.ok) return check;

    var body = gridScrollEl();
    if (origin === 'results') {
      state._savedScrollTop = body ? body.scrollTop : 0;
    }

    state.pendingScent = scent;
    var existing = currentSlotStrength(check.slot);
    state.pendingStrength = existing || STRENGTH_DEFAULT;
    if (origin === 'detail') state._strengthOrigin = 'detail';
    else if (origin === 'edit') state._strengthOrigin = 'edit';
    else state._strengthOrigin = 'results';
    state.strengthOpen = true;
    state._applying = false;

    var results = resultsView();
    var detail = detailPanel();
    var strength = strengthPanel();
    if (results) results.hidden = true;
    if (detail) detail.hidden = true;
    if (strength) strength.hidden = false;

    // Ensure Confirm is reachable (footer now inside scrollable strength-body)
    try {
      var confBtn = state.modal.querySelector('[data-salus-sd-strength-confirm]');
      if (confBtn && typeof confBtn.scrollIntoView === 'function') {
        requestAnimationFrame(function () {
          try { confBtn.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e1) {}
        });
      }
    } catch (e2) {}


    var name = scent.display_name || scent.keystone_value || 'Scent';
    var posEl = state.modal.querySelector('[data-salus-sd-strength-position]');
    var nameEl = state.modal.querySelector('[data-salus-sd-strength-name]');
    if (posEl) posEl.textContent = positionLabel(check.slot);
    if (nameEl) nameEl.textContent = name;
    var changeBtn = state.modal.querySelector('[data-salus-sd-strength-change]');
    if (changeBtn) changeBtn.hidden = state._strengthOrigin !== 'edit';
    var backBtn = state.modal.querySelector('[data-salus-sd-strength-back]');
    if (backBtn) {
      // Edit: Change scent is primary browse control; Back still discards to results
      backBtn.hidden = false;
    }
    showStrengthError('');
    setConfirmBusy(false);
    renderStrengthChoices();

    var firstRadio = state.modal.querySelector('[data-salus-sd-strength-group] input[type="radio"]:checked') ||
      state.modal.querySelector('[data-salus-sd-strength-group] input[type="radio"]');
    try { if (firstRadio) firstRadio.focus(); } catch (e) {}
    return { ok: true, pending: true, slot: check.slot };
  }

  function closeStrengthView(opts) {
    opts = opts || {};
    if (!state.modal) return;
    var origin = state._strengthOrigin || 'results';
    state.strengthOpen = false;
    discardPending();
    showStrengthError('');
    setConfirmBusy(false);
    if (state.modal) {
      var changeBtnClose = state.modal.querySelector('[data-salus-sd-strength-change]');
      if (changeBtnClose) changeBtnClose.hidden = true;
    }

    var results = resultsView();
    var detail = detailPanel();
    var strength = strengthPanel();
    if (strength) strength.hidden = true;

    if (opts.andCloseModal) {
      if (detail) detail.hidden = true;
      if (results) results.hidden = false;
      state.detailOpen = false;
      return;
    }

    if (origin === 'detail' && state._detailHandle) {
      state.detailOpen = true;
      if (results) results.hidden = true;
      if (detail) detail.hidden = false;
      var backBtn = detail && detail.querySelector('[data-salus-sd-detail-back]');
      try { if (backBtn) backBtn.focus(); } catch (e) {}
      return;
    }

    // Return to results; preserve filters/page/scroll
    state.detailOpen = false;
    if (detail) detail.hidden = true;
    if (results) results.hidden = false;
    renderModalContent();
    var body = gridScrollEl();
    if (body) {
      try { body.scrollTop = state._savedScrollTop || 0; } catch (e2) {}
    }
    var search = state.modal.querySelector('[data-salus-sd-search]');
    try { if (search) search.focus(); } catch (e3) {}
  }

  /** From Edit strength step: browse/results without requiring a re-search. Pending discarded. */
  function changeScentFromStrength() {
    if (!state.modal || state._applying) return;
    state.strengthOpen = false;
    discardPending();
    showStrengthError('');
    setConfirmBusy(false);
    var results = resultsView();
    var detail = detailPanel();
    var strength = strengthPanel();
    if (strength) strength.hidden = true;
    if (detail) detail.hidden = true;
    state.detailOpen = false;
    state._detailHandle = '';
    if (results) results.hidden = false;
    var changeBtn = state.modal.querySelector('[data-salus-sd-strength-change]');
    if (changeBtn) changeBtn.hidden = true;
    // Preserve filters/query/page so user is not forced to re-search
    renderModalContent();
    var search = state.modal.querySelector('[data-salus-sd-search]');
    try { if (search) search.focus(); } catch (e) {}
  }

  function valuesMatch(a, b) {
    return String(a == null ? '' : a).trim() === String(b == null ? '' : b).trim();
  }

  function confirmPending() {
    if (state._applying) return { ok: false, error: 'busy' };
    var scent = state.pendingScent;
    var strengthValue = state.pendingStrength;
    var check = validatePendingChoice(scent, state.activeSlot);
    if (!check.ok) {
      showStrengthError('This scent is no longer available for this position. Go back and choose another.');
      return check;
    }
    if (!isValidStrength(strengthValue)) {
      showStrengthError('Please choose LIGHT — Subtle, REGULAR — Normal, or HEAVY — Stronger.');
      return { ok: false, error: 'invalid_strength' };
    }

    var slot = check.slot;
    var scentId = KS_SCENT[slot];
    var strengthId = KS_STRENGTH[slot];
    var scentValue = check.value;
    var priorScent = usable(getValue(scentId));
    var priorStrength = usable(getValue(strengthId));

    state._applying = true;
    setConfirmBusy(true);
    showStrengthError('');

    var scentSet = setValue(scentId, scentValue);
    var strengthSet = setValue(strengthId, strengthValue);
    refreshProperties();

    var scentRead = getValue(scentId);
    var strengthRead = getValue(strengthId);
    var scentOk = valuesMatch(scentRead, scentValue) || scentSet;
    var strengthOk = valuesMatch(strengthRead, strengthValue) || strengthSet;
    // Prefer readback truth
    scentOk = valuesMatch(scentRead, scentValue);
    strengthOk = valuesMatch(strengthRead, strengthValue);

    if (!scentOk || !strengthOk) {
      // Restore prior values for this slot only
      if (priorScent) setValue(scentId, priorScent);
      else setValue(scentId, '');
      if (priorStrength) setValue(strengthId, priorStrength);
      else setValue(strengthId, '');
      refreshProperties();
      state._applying = false;
      setConfirmBusy(false);
      showStrengthError('Could not apply scent and strength. Nothing was changed. Please try again.');
      return {
        ok: false,
        error: 'setValue_failed',
        scentRead: scentRead,
        strengthRead: strengthRead
      };
    }

    // Success: close Discovery, unlock scroll, refresh Choose/Edit UI, focus Edit control
    state._applying = false;
    setConfirmBusy(false);
    state.strengthOpen = false;
    discardPending();
    var strengthEl = strengthPanel();
    if (strengthEl) strengthEl.hidden = true;
    state.detailOpen = false;
    state._detailHandle = '';
    closeModal();
    render();
    var editBtn = document.querySelector('[' + EDIT_ATTR + '="' + slot + '"]');
    var chooseBtn = document.querySelector('[' + BTN_ATTR + '="' + slot + '"]');
    var focusEl = editBtn || chooseBtn;
    if (focusEl && typeof focusEl.focus === 'function') {
      try { focusEl.focus(); } catch (eFocus) {}
    }
    return {
      ok: true,
      slot: slot,
      scent: scentValue,
      strength: strengthValue,
      scentRead: scentRead,
      strengthRead: strengthRead
    };
  }

  /** UI Select → strength step only (no Keystone write until Confirm). */
  function selectScent(scent, origin) {
    return openStrengthView(scent, origin || (state.detailOpen ? 'detail' : 'results'));
  }

  function findScentByHandle(handle) {
    var scents = (state.catalog && state.catalog.scents) || [];
    for (var i = 0; i < scents.length; i++) {
      if (scents[i].handle === handle || scents[i].keystone_handle === handle) return scents[i];
    }
    return null;
  }

  function findScentSelect(slot) {
    var optionId = KS_SCENT[slot];
    if (!optionId) return null;
    var block = document.getElementById('key_options_block');
    if (!block) return null;
    var selects = block.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      if (matchesOptionControl(selects[i], optionId)) return selects[i];
    }
    return null;
  }

  function lockBodyScroll() {
    if (document.body.classList.contains('salus-sd-modal-open')) return;
    state._bodyOverflow = document.body.style.overflow || '';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('salus-sd-modal-open');
  }

  function unlockBodyScroll() {
    document.body.classList.remove('salus-sd-modal-open');
    document.body.style.overflow = state._bodyOverflow || '';
  }

  function focusableIn(container) {
    if (!container) return [];
    var list = $all(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      container
    );
    return list.filter(function (el) {
      if (el.hidden) return false;
      if (el.getAttribute('aria-hidden') === 'true') return false;
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      return true;
    });
  }

  function trapFocus(e) {
    if (!state.open || !state.modal || state.modal.hidden) return;
    if (e.key !== 'Tab') return;
    var dialog = state.modal.querySelector('[data-salus-sd-dialog]');
    var focusables = focusableIn(dialog);
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      if (state.strengthOpen) {
        e.preventDefault();
        if (!state._applying) closeStrengthView();
        return;
      }
      if (state.detailOpen) {
        e.preventDefault();
        closeDetail();
        return;
      }
      if (state.open) {
        e.preventDefault();
        closeModal();
        return;
      }
    }
    trapFocus(e);
  }

  function resultsView() {
    return state.modal && state.modal.querySelector('[data-salus-sd-results]');
  }

  function detailPanel() {
    return state.modal && state.modal.querySelector('[data-salus-sd-detail-panel]');
  }

  function gridScrollEl() {
    return state.modal && state.modal.querySelector('[data-salus-sd-body]');
  }

  function updateSelectRowLayout(row) {
    if (!row) return;
    var stacked = row.clientWidth > 0 && row.clientWidth < 360;
    row.classList.toggle('is-stacked', stacked);
    var wrap = row.querySelector('.salus-sd__trigger-wrap');
    if (wrap) wrap.classList.toggle('is-stacked', stacked);
  }

  function ensureModal() {
    if (state.modal) return state.modal;
    var root = document.createElement('div');
    root.className = 'salus-sd__modal-root';
    root.setAttribute('data-salus-sd-modal-root', '');
    root.hidden = true;
    root.innerHTML =
      '<div class="salus-sd__modal-backdrop" data-salus-sd-backdrop tabindex="-1"></div>' +
      '<div class="salus-sd__modal" role="dialog" aria-modal="true" aria-labelledby="salus-sd-modal-title" data-salus-sd-dialog>' +
      '  <div class="salus-sd__modal-inner">' +
      '    <div class="salus-sd__modal-top">' +
      '      <button type="button" class="salus-sd__modal-close" data-salus-sd-close aria-label="Close">' +
      '        <span aria-hidden="true">×</span> Close' +
      '      </button>' +
      '    </div>' +
      '    <header class="salus-sd__modal-header">' +
      '      <h2 class="salus-sd__modal-title" id="salus-sd-modal-title">Discover Scents</h2>' +
      '      <p class="salus-sd__modal-subtitle" data-salus-sd-subtitle></p>' +
      '    </header>' +
      '    <div class="salus-sd__results" data-salus-sd-results>' +
      '      <div class="salus-sd__modal-controls">' +
      '        <label class="salus-sd__search-wrap">' +
      '          <span class="salus-sd__search-icon" aria-hidden="true">' +
      '            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>' +
      '          </span>' +
      '          <input type="search" class="salus-sd__search" data-salus-sd-search placeholder="Search scents" aria-label="Search scents" autocomplete="off">' +
      '        </label>' +
      '        <div class="salus-sd__chips" role="toolbar" aria-label="Scent categories" data-salus-sd-chips></div>' +
      '      </div>' +
      '      <div class="salus-sd__modal-body" data-salus-sd-body>' +
      '        <div class="salus-sd__grid" data-salus-sd-grid></div>' +
      '      </div>' +
      '      <footer class="salus-sd__modal-footer">' +
      '        <p class="salus-sd__count" data-salus-sd-count></p>' +
      '        <nav class="salus-sd__pager" aria-label="Scent results pages" data-salus-sd-pager></nav>' +
      '      </footer>' +
      '    </div>' +
      '    <div class="salus-sd__detail-panel" data-salus-sd-detail-panel hidden>' +
      '      <div class="salus-sd__detail-header">' +
      '        <h3 class="salus-sd__detail-title" id="salus-sd-detail-title" data-salus-sd-detail-title></h3>' +
      '      </div>' +
      '      <div class="salus-sd__detail-body" data-salus-sd-detail-body></div>' +
      '      <div class="salus-sd__detail-footer">' +
      '        <button type="button" class="salus-sd__btn salus-sd__btn--ghost" data-salus-sd-detail-back>Back</button>' +
      '        <button type="button" class="salus-sd__btn salus-sd__btn--primary" data-salus-sd-detail-select>Select</button>' +
      '      </div>' +
      '    </div>' +
      '    <div class="salus-sd__strength-panel" data-salus-sd-strength-panel hidden>' +
      '      <div class="salus-sd__strength-header">' +
      '        <p class="salus-sd__strength-position" data-salus-sd-strength-position></p>' +
      '        <h3 class="salus-sd__strength-name" id="salus-sd-strength-title" data-salus-sd-strength-name></h3>' +
      '        <p class="salus-sd__strength-prompt" id="salus-sd-strength-prompt">How Strong Would You Like Your Scent?</p>' +
      '      </div>' +
      '      <div class="salus-sd__strength-body">' +
      '        <div class="salus-sd__strength-group" role="radiogroup" aria-labelledby="salus-sd-strength-prompt" data-salus-sd-strength-group></div>' +
      '        <p class="salus-sd__strength-error" data-salus-sd-strength-error role="alert" hidden></p>' +
      '        <div class="salus-sd__strength-footer">' +
      '          <button type="button" class="salus-sd__btn salus-sd__btn--ghost" data-salus-sd-strength-back>Back</button>' +
      '          <button type="button" class="salus-sd__btn salus-sd__btn--ghost" data-salus-sd-strength-change hidden>Change scent</button>' +
      '          <button type="button" class="salus-sd__btn salus-sd__btn--primary" data-salus-sd-strength-confirm>Confirm scent &amp; strength</button>' +
      '        </div>' +
      '      </div>' +
      '    </div>' +
      '  </div>' +
      '</div>';
    document.body.appendChild(root);

    root.querySelector('[data-salus-sd-backdrop]').addEventListener('click', function () {
      if (!state._backdropArmed) return;
      if (!state._applying) closeModal();
    });
    root.querySelector('[data-salus-sd-close]').addEventListener('click', function () {
      if (!state._applying) closeModal();
    });
    root.querySelector('[data-salus-sd-detail-back]').addEventListener('click', function () { closeDetail(); });
    root.querySelector('[data-salus-sd-detail-select]').addEventListener('click', function () {
      var handle = state._detailHandle || root.getAttribute('data-detail-handle');
      var scent = findScentByHandle(handle);
      selectScent(scent, 'detail');
    });
    root.querySelector('[data-salus-sd-strength-back]').addEventListener('click', function () {
      if (!state._applying) closeStrengthView();
    });
    root.querySelector('[data-salus-sd-strength-change]').addEventListener('click', function () {
      if (!state._applying) changeScentFromStrength();
    });
    root.querySelector('[data-salus-sd-strength-confirm]').addEventListener('click', function () {
      confirmPending();
    });

    var search = root.querySelector('[data-salus-sd-search]');
    search.addEventListener('input', function () {
      state.query = search.value || '';
      state.page = 1;
      renderModalContent();
      var b = gridScrollEl();
      if (b) { try { b.scrollTop = 0; } catch (eScroll2) {} }
    });

    state.modal = root;
    return root;
  }

  function openDetail(scent, fromBtn) {
    if (!scent || !state.modal) return;
    if (state.strengthOpen) return;
    ensureModal();
    var body = gridScrollEl();
    state._savedScrollTop = body ? body.scrollTop : 0;
    state._learnMoreBtn = fromBtn || null;
    state._learnMoreHandle = (fromBtn && fromBtn.getAttribute && fromBtn.getAttribute('data-salus-sd-learn')) || (scent.handle || scent.keystone_handle || '') || '';
    state.detailOpen = true;
    state._detailHandle = scent.handle || scent.keystone_handle || '';
    state.modal.setAttribute('data-detail-handle', state._detailHandle);

    var results = resultsView();
    var panel = detailPanel();
    if (results) results.hidden = true;
    if (panel) panel.hidden = false;

    var name = scent.display_name || scent.keystone_value || 'Scent';
    panel.querySelector('[data-salus-sd-detail-title]').textContent = name;

    var catsHtml = '';
    var handles = scent.category_handles || [];
    if (handles.length) {
      catsHtml = '<div class="salus-sd__detail-cats">' + handles.map(function (h) {
        return '<span class="salus-sd__detail-cat">' + escapeHtml(categoryTitle(h)) + '</span>';
      }).join('') + '</div>';
    }
    var media = scent.image_url
      ? '<div class="salus-sd__detail-media"><img src="' + escapeHtml(scent.image_url) + '" alt=""></div>'
      : emptyMediaHtml(name, 'detail');

    var descHtml;
    if (scent.description && String(scent.description).trim()) {
      descHtml = renderParsedDescription(parseDescription(scent.description));
    } else if (scent.short_copy && String(scent.short_copy).trim()) {
      descHtml = '<p class="salus-sd__detail-desc">' + escapeHtml(scent.short_copy) + '</p>';
    } else {
      descHtml = '<p class="salus-sd__detail-desc salus-sd__detail-desc--muted">Description unavailable</p>';
    }

    panel.querySelector('[data-salus-sd-detail-body]').innerHTML = media + catsHtml + descHtml;

    var backBtn = panel.querySelector('[data-salus-sd-detail-back]');
    try { if (backBtn) backBtn.focus(); } catch (e) {}
  }

  function closeDetail(skipFocusRestore) {
    if (!state.modal) return;
    state.detailOpen = false;
    state._detailHandle = '';
    state.modal.removeAttribute('data-detail-handle');
    var results = resultsView();
    var panel = detailPanel();
    if (panel) panel.hidden = true;
    if (results) results.hidden = false;

    // Restore filters are already in state; re-render to keep DOM in sync then restore scroll
    renderModalContent();
    var body = gridScrollEl();
    if (body) {
      try { body.scrollTop = state._savedScrollTop || 0; } catch (e) {}
    }

    if (!skipFocusRestore) {
      var handle = state._learnMoreHandle || '';
      var btn = state._learnMoreBtn;
      state._learnMoreBtn = null;
      state._learnMoreHandle = '';
      var restored = null;
      if (handle) {
        restored = state.modal.querySelector('[data-salus-sd-learn="' + handle + '"]');
      }
      if (!restored && btn && document.contains(btn)) restored = btn;
      if (restored && typeof restored.focus === 'function') {
        try { restored.focus(); return; } catch (e2) {}
      }
      var search = state.modal.querySelector('[data-salus-sd-search]');
      try { if (search) search.focus(); } catch (e3) {}
    } else {
      state._learnMoreBtn = null;
      state._learnMoreHandle = '';
    }
  }

  function openModal(slot, triggerEl) {
    if (!state.catalog) return;
    var avail = availableSlots();
    var n = Number(slot) || 1;
    if (avail.indexOf(n) === -1) n = avail[0] || 1;
    state.activeSlot = n;
    state.page = 1;
    ensureModal();
    // Ensure results view visible if leftover detail/strength
    state.detailOpen = false;
    state.strengthOpen = false;
    state._detailHandle = '';
    discardPending();
    var results = resultsView();
    var panel = detailPanel();
    var strength = strengthPanel();
    if (results) results.hidden = false;
    if (panel) panel.hidden = true;
    if (strength) strength.hidden = true;

    state.lastFocus = triggerEl || document.activeElement;
    state.triggerBtn = triggerEl || null;
    state.open = true;
    state.modal.hidden = false;
    state._backdropArmed = false;
    state._openGuardUntil = Date.now() + 900;
    lockBodyScroll();
    document.addEventListener('keydown', onKeydown, true);
    renderModalContent();
    var search = state.modal.querySelector('[data-salus-sd-search]');
    if (search) {
      search.value = state.query || '';
      try { search.focus(); } catch (e) {}
    }
    // Arm backdrop/outside close after the opening gesture settles (prevents open→close flicker).
    setTimeout(function () { state._backdropArmed = true; }, 320);
  }

  /** Edit: open Discovery on strength step for current confirmed scent (strength-only ready). */
  function openEditModal(slot, triggerEl) {
    if (!state.catalog) return;
    var avail = availableSlots();
    var n = Number(slot) || 1;
    if (avail.indexOf(n) === -1) n = avail[0] || 1;
    var scentVal = currentSlotScentValue(n);
    var scent = findScentByKeystoneValue(scentVal);
    if (!scent) {
      // No confirmed scent — fall back to Choose flow
      state.query = '';
      state.category = 'all';
      state.page = 1;
      openModal(n, triggerEl);
      return;
    }
    state.activeSlot = n;
    // Keep existing filters; do not force blank search merely to edit strength
    ensureModal();
    state.detailOpen = false;
    state.strengthOpen = false;
    state._detailHandle = '';
    discardPending();
    var results = resultsView();
    var panel = detailPanel();
    var strength = strengthPanel();
    if (results) results.hidden = false;
    if (panel) panel.hidden = true;
    if (strength) strength.hidden = true;

    state.lastFocus = triggerEl || document.activeElement;
    state.triggerBtn = triggerEl || null;
    state.open = true;
    state.modal.hidden = false;
    state._backdropArmed = false;
    state._openGuardUntil = Date.now() + 900;
    lockBodyScroll();
    document.addEventListener('keydown', onKeydown, true);
    renderModalContent();
    openStrengthView(scent, 'edit');
    setTimeout(function () { state._backdropArmed = true; }, 320);
  }

  function closeModal() {
    if (!state.modal) return;
    if (state._applying) return;
    state._backdropArmed = false;
    state._openGuardUntil = 0;
    // Discard any unconfirmed pending; never write Keystone on close
    if (state.strengthOpen) {
      state.strengthOpen = false;
      discardPending();
      var strength = strengthPanel();
      if (strength) strength.hidden = true;
      showStrengthError('');
      setConfirmBusy(false);
    }
    if (state.detailOpen) {
      state.detailOpen = false;
      state._detailHandle = '';
      state._learnMoreBtn = null;
      var results = resultsView();
      var panel = detailPanel();
      if (panel) panel.hidden = true;
      if (results) results.hidden = false;
      state.modal.removeAttribute('data-detail-handle');
    }
    state.open = false;
    state.modal.hidden = true;
    document.removeEventListener('keydown', onKeydown, true);
    unlockBodyScroll();
    var restore = state.triggerBtn || state.lastFocus;
    if (restore && typeof restore.focus === 'function') {
      try { restore.focus(); } catch (e) {}
    }
    state.triggerBtn = null;
  }

  function renderModalContent() {
    if (!state.modal || !state.catalog) return;
    // Do not overwrite results while detail is showing unless closing detail called us
    var root = state.modal;
    root.querySelector('[data-salus-sd-subtitle]').textContent = slotHeading(state.activeSlot);

    var intersected = intersectCatalogForSlot(state.activeSlot);
    var filtered = filterScents(intersected.scents);
    state._lastFiltered = filtered;
    state._lastValid = intersected.valid;

    var total = filtered.length;
    /* 2026-09-08 owner: continuous scroll list (supersedes PAGE_SIZE=6 pagination). */
    var pageItems = filtered;
    var start = 0;

    var cats = state.catalog.categories || [];
    var chips = [{ handle: 'all', title: 'All' }].concat(cats.map(function (c) {
      return { handle: c.category_handle || c.handle, title: c.title || c.category_handle || c.handle };
    }));
    var chipsEl = root.querySelector('[data-salus-sd-chips]');
    chipsEl.innerHTML = chips.map(function (c) {
      var active = (state.category || 'all') === c.handle;
      return '<button type="button" class="salus-sd__chip' + (active ? ' is-active' : '') + '" data-salus-sd-chip="' +
        escapeHtml(c.handle) + '" aria-pressed="' + (active ? 'true' : 'false') + '">' + escapeHtml(c.title) + '</button>';
    }).join('');
    $all('[data-salus-sd-chip]', chipsEl).forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.category = btn.getAttribute('data-salus-sd-chip') || 'all';
        state.page = 1;
        renderModalContent();
        var b = gridScrollEl();
        if (b) { try { b.scrollTop = 0; } catch (eScroll) {} }
      });
    });

    var grid = root.querySelector('[data-salus-sd-grid]');
    if (!pageItems.length) {
      grid.innerHTML = '<p class="salus-sd__empty">No scents match your search.</p>';
    } else {
      grid.innerHTML = pageItems.map(function (s) {
        var name = s.display_name || s.keystone_value || 'Scent';
        var media = s.image_url
          ? '<div class="salus-sd__card-media"><img src="' + escapeHtml(s.image_url) + '" alt="" loading="lazy"></div>'
          : emptyMediaHtml(name, 'card');
        var handle = escapeHtml(s.handle || s.keystone_handle || '');
        return (
          '<article class="salus-sd__card" data-scent-handle="' + handle + '">' +
          media +
          '<h3 class="salus-sd__card-name">' + escapeHtml(name) + '</h3>' +
          '<div class="salus-sd__card-actions">' +
          '<button type="button" class="salus-sd__link" data-salus-sd-learn="' + handle + '" aria-label="Scent notes for ' + escapeHtml(name) + '">Scent Notes</button>' +
          '<button type="button" class="salus-sd__btn salus-sd__btn--primary" data-salus-sd-select="' + handle + '">Select</button>' +
          '</div></article>'
        );
      }).join('');
      $all('[data-salus-sd-learn]', grid).forEach(function (btn) {
        btn.addEventListener('click', function () {
          openDetail(findScentByHandle(btn.getAttribute('data-salus-sd-learn')), btn);
        });
      });
      $all('[data-salus-sd-select]', grid).forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectScent(findScentByHandle(btn.getAttribute('data-salus-sd-select')), 'results');
        });
      });
    }

    var countEl = root.querySelector('[data-salus-sd-count]');
    if (!total) {
      countEl.textContent = 'Showing 0 scents';
    } else {
      countEl.textContent = 'Showing ' + total + (total === 1 ? ' scent' : ' scents');
    }

    var pager = root.querySelector('[data-salus-sd-pager]');
    if (pager) {
      pager.hidden = true;
      pager.innerHTML = '';
      pager.setAttribute('aria-hidden', 'true');
    }
  }

  function clearSlotValidation(slot) {
    if (!state._slotErrors) state._slotErrors = {};
    delete state._slotErrors[slot];
    var block = document.getElementById('key_options_block');
    if (!block) return;
    var err = block.querySelector('[data-salus-sd-slot-error="' + slot + '"]');
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }
    var ui = block.querySelector('[' + SLOT_UI_ATTR + '="' + slot + '"]');
    if (ui) ui.classList.remove('has-error');
    var btn = block.querySelector('[' + BTN_ATTR + '="' + slot + '"], [' + EDIT_ATTR + '="' + slot + '"]');
    if (btn) btn.removeAttribute('aria-invalid');
  }

  function showSlotValidation(slot, msg) {
    if (!state._slotErrors) state._slotErrors = {};
    if (msg) state._slotErrors[slot] = msg;
    else delete state._slotErrors[slot];
    var block = document.getElementById('key_options_block');
    if (!block) return;
    var ui = block.querySelector('[' + SLOT_UI_ATTR + '="' + slot + '"]');
    var err = block.querySelector('[data-salus-sd-slot-error="' + slot + '"]');
    if (err) {
      err.hidden = !msg;
      err.textContent = msg || '';
    }
    if (ui) ui.classList.toggle('has-error', !!msg);
    var action = block.querySelector('[' + EDIT_ATTR + '="' + slot + '"]') ||
      block.querySelector('[' + BTN_ATTR + '="' + slot + '"]');
    if (action) {
      if (msg) action.setAttribute('aria-invalid', 'true');
      else action.removeAttribute('aria-invalid');
      try { action.focus(); } catch (e) {}
    }
  }

  function reapplySlotValidationMessages() {
    if (!state._slotErrors) return;
    var slots = Object.keys(state._slotErrors);
    var i;
    for (i = 0; i < slots.length; i++) {
      var slot = Number(slots[i]);
      var msg = state._slotErrors[slots[i]];
      if (!msg) continue;
      // Re-apply DOM without clobbering the saved map
      var block = document.getElementById('key_options_block');
      if (!block) continue;
      var ui = block.querySelector('[' + SLOT_UI_ATTR + '="' + slot + '"]');
      var err = block.querySelector('[data-salus-sd-slot-error="' + slot + '"]');
      if (err) {
        err.hidden = false;
        err.textContent = msg;
      }
      if (ui) ui.classList.add('has-error');
      var action = block.querySelector('[' + EDIT_ATTR + '="' + slot + '"]') ||
        block.querySelector('[' + BTN_ATTR + '="' + slot + '"]');
      if (action) action.setAttribute('aria-invalid', 'true');
    }
  }

  /** Durable Natural check via visible radio — avoids KO getValue flicker closing Discovery. */
  function isNaturalRadioChecked() {
    var block = document.getElementById('key_options_block');
    if (!block) return false;
    var nodes = block.querySelectorAll('input[type="radio"]');
    var i;
    for (i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var idish = ((el.name || '') + ' ' + (el.id || '') + ' ' + (el.getAttribute('data-option-id') || ''));
      if (idish.indexOf(String(KS_SCENTING)) === -1) continue;
      if (!el.checked) continue;
      return /natural|no scent|unscented/i.test(String(el.value || ''));
    }
    return false;
  }

  function slotForOptionId(optionId) {
    var id = Number(optionId);
    var s;
    for (s = 1; s <= 5; s++) {
      if (KS_SCENT[s] === id || KS_STRENGTH[s] === id) return s;
    }
    return 0;
  }

  function slotForKeystoneControl(el) {
    if (!el) return 0;
    var idish = ((el.name || '') + ' ' + (el.id || '') + ' ' + (el.getAttribute('data-option-id') || ''));
    var s;
    for (s = 1; s <= 5; s++) {
      if (idish.indexOf(String(KS_SCENT[s])) !== -1 || idish.indexOf(String(KS_STRENGTH[s])) !== -1) return s;
    }
    var wrap = el.closest && el.closest('.key_option');
    if (wrap) {
      var sel = wrap.querySelector('select');
      if (sel) return slotForKeystoneControl(sel);
      var rad = wrap.querySelector('input[type="radio"]');
      if (rad) return slotForKeystoneControl(rad);
    }
    return 0;
  }

  function restoreKeystoneChrome() {
    var block = document.getElementById('key_options_block');
    if (!block) return;
    $all('.' + KS_CHROME_HIDE, block).forEach(function (el) {
      el.classList.remove(KS_CHROME_HIDE);
    });
    state._chromeHidden = false;
  }

  function hideKeystoneChromeForSlots(availSet) {
    var block = document.getElementById('key_options_block');
    if (!block || !state._enhancedReady) {
      restoreKeystoneChrome();
      return;
    }
    var slot;
    for (slot = 1; slot <= 5; slot++) {
      var sel = findScentSelect(slot);
      var scentWrap = findKeyOptionWrap(sel);
      var radios = findStrengthRadios(slot);
      var strengthWrap = radios.length ? findKeyOptionWrap(radios[0]) : null;
      if (availSet[slot]) {
        if (scentWrap) scentWrap.classList.add(KS_CHROME_HIDE);
        if (strengthWrap) strengthWrap.classList.add(KS_CHROME_HIDE);
      } else {
        if (scentWrap) scentWrap.classList.remove(KS_CHROME_HIDE);
        if (strengthWrap) strengthWrap.classList.remove(KS_CHROME_HIDE);
      }
    }
    state._chromeHidden = true;
  }

  function buildSlotUiContent(slot, confirmed) {
    var label = positionLabel(slot);
    var html = '<div class="salus-sd__slot-label">' + escapeHtml(label) + '</div>';
    if (confirmed) {
      var scentName = confirmed.name;
      var strengthLabel = confirmed.strengthShort;
      var summary = scentName + (strengthLabel ? (' · ' + strengthLabel) : '');
      html +=
        '<div class="salus-sd__slot-summary">' +
        '<p class="salus-sd__slot-choice">' + escapeHtml(summary) + '</p>' +
        '<button type="button" class="salus-sd__slot-edit" ' + EDIT_ATTR + '="' + slot + '" aria-haspopup="dialog">' +
        'Edit scent &amp; strength</button>' +
        '</div>';
    } else {
      html +=
        '<button type="button" class="salus-sd__discover-btn" ' + BTN_ATTR + '="' + slot +
        '" aria-haspopup="dialog">' + escapeHtml(chooseButtonLabel(slot)) + '</button>';
    }
    html += '<p class="salus-sd__slot-error" data-salus-sd-slot-error="' + slot + '" role="alert" hidden></p>';
    return html;
  }

  function confirmedStateForSlot(slot) {
    var scentVal = currentSlotScentValue(slot);
    if (!scentVal) return null;
    var scent = findScentByKeystoneValue(scentVal);
    var name = (scent && (scent.display_name || scent.keystone_value)) || scentVal;
    var strength = currentSlotStrength(slot);
    return {
      name: name,
      strength: strength,
      strengthShort: strength ? strengthShortLabel(strength) : ''
    };
  }

  function bindSlotUi(ui, slot) {
    var choose = ui.querySelector('[' + BTN_ATTR + '="' + slot + '"]');
    if (choose) {
      choose.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearSlotValidation(slot);
        state.query = '';
        state.category = 'all';
        state.page = 1;
        openModal(slot, e.currentTarget);
      });
    }
    var edit = ui.querySelector('[' + EDIT_ATTR + '="' + slot + '"]');
    if (edit) {
      edit.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearSlotValidation(slot);
        openEditModal(slot, e.currentTarget);
      });
    }
  }

  function removeLegacyTriggers(block) {
    $all('[' + WRAP_ATTR + ']', block).forEach(function (wrap) {
      var row = wrap.parentNode;
      if (row && row.classList && row.classList.contains('salus-sd__select-row')) {
        row.classList.remove('salus-sd__select-row', 'is-stacked');
      }
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    });
  }

  function injectSlotControls() {
    var block = document.getElementById('key_options_block');
    if (!block) return;

    if (shouldForceFallback()) {
      state._enhancedReady = false;
    }

    var natural = !isCustomize();
    var avail = natural ? [] : availableSlots();
    var availSet = Object.create(null);
    var a;
    for (a = 0; a < avail.length; a++) availSet[avail[a]] = true;

    // Fallback / Discovery unavailable: strip ALL Choose/Edit cards (no dual path)
    if (!state._enhancedReady) {
      var guardFb = state.open && state._openGuardUntil && Date.now() < state._openGuardUntil;
      if (guardFb) return;
      removeAllSlotUis(block);
      removeLegacyTriggers(block);
      restoreKeystoneChrome();
      if (state.open) forceCloseDiscovery();
      return;
    }

    // Natural: remove all slot UIs and show Keystone scenting chrome
    // Require durable Natural radio to avoid KO flicker tearing down Discovery mid-open.
    if (natural) {
      if (state.open && !isNaturalRadioChecked()) return;
      var guardNat = state.open && state._openGuardUntil && Date.now() < state._openGuardUntil;
      if (guardNat && !isNaturalRadioChecked()) return;
      removeAllSlotUis(block);
      removeLegacyTriggers(block);
      restoreKeystoneChrome();
      if (state.open) closeModal();
      return;
    }

    // Remove slot UIs that are no longer available
    $all('[' + SLOT_UI_ATTR + ']', block).forEach(function (ui) {
      var slot = Number(ui.getAttribute(SLOT_UI_ATTR));
      if (!availSet[slot]) {
        if (ui.parentNode) ui.parentNode.removeChild(ui);
      }
    });

    removeLegacyTriggers(block);

    var slot;
    for (slot = 1; slot <= 5; slot++) {
      if (!availSet[slot]) continue;
      var select = findScentSelect(slot);
      if (!select) continue;
      var scentWrap = findKeyOptionWrap(select);
      if (!scentWrap || !scentWrap.parentNode) continue;

      var confirmed = confirmedStateForSlot(slot);
      var existing = block.querySelector('[' + SLOT_UI_ATTR + '="' + slot + '"]');
      var content = buildSlotUiContent(slot, confirmed);
      if (existing) {
        var prev = existing.getAttribute('data-salus-sd-ui-html') || '';
        if (prev !== content) {
          existing.innerHTML = content;
          existing.setAttribute('data-salus-sd-ui-html', content);
          bindSlotUi(existing, slot);
        }
        existing.classList.toggle('is-confirmed', !!confirmed);
      } else {
        var ui = document.createElement('div');
        ui.className = 'salus-sd__slot-ui' + (confirmed ? ' is-confirmed' : '');
        ui.setAttribute(SLOT_UI_ATTR, String(slot));
        ui.setAttribute('data-salus-sd-ui-html', content);
        ui.innerHTML = content;
        scentWrap.parentNode.insertBefore(ui, scentWrap);
        bindSlotUi(ui, slot);
      }
    }

    hideKeystoneChromeForSlots(availSet);
    reapplySlotValidationMessages();
    bindProductFormSubmitGuard();
  }

  function onHiddenControlFocus(e) {
    if (!state._chromeHidden) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var chrome = t.closest('.' + KS_CHROME_HIDE);
    if (!chrome) return;
    var slot = slotForKeystoneControl(t) || slotForKeystoneControl(chrome.querySelector('select, input'));
    if (!slot) return;
    try { e.preventDefault(); } catch (err) {}
    try { e.stopPropagation(); } catch (err2) {}
    // Blur hidden control then move focus to visible Choose/Edit
    try { if (typeof t.blur === 'function') t.blur(); } catch (err3) {}
    showSlotValidation(slot, 'Please choose a scent and strength for this position.');
  }

  function onHiddenControlInvalid(e) {
    if (!state._chromeHidden) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('.' + KS_CHROME_HIDE)) return;
    var slot = slotForKeystoneControl(t);
    if (!slot) return;
    e.preventDefault();
    showSlotValidation(slot, 'Please choose a scent and strength for this position.');
  }

  function bindValidationRedirect() {
    if (state._validationBound) return;
    state._validationBound = true;
    document.addEventListener('focusin', onHiddenControlFocus, true);
    document.addEventListener('invalid', onHiddenControlInvalid, true);
    // When Keystone toggles aria-invalid on hidden fields, surface beside visible action
    var block = document.getElementById('key_options_block');
    if (!block || typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(function (mutations) {
      if (!state._chromeHidden) return;
      var i, m, t, slot;
      for (i = 0; i < mutations.length; i++) {
        m = mutations[i];
        if (m.type !== 'attributes' || m.attributeName !== 'aria-invalid') continue;
        t = m.target;
        if (!t || !t.closest || !t.closest('.' + KS_CHROME_HIDE)) continue;
        if (String(t.getAttribute('aria-invalid')) !== 'true') continue;
        slot = slotForKeystoneControl(t);
        if (slot) showSlotValidation(slot, 'Please choose a scent and strength for this position.');
      }
    });
    obs.observe(block, { attributes: true, subtree: true, attributeFilter: ['aria-invalid'] });
  }

  /** @deprecated name kept via alias — use injectSlotControls */
  function injectTriggers() {
    injectSlotControls();
  }

  function syncHost() {
    if (!state.root) return;
    state.root.hidden = true;
    state.root.setAttribute('aria-hidden', 'true');
    state.root.classList.add('is-shell');
    if (!state.root.innerHTML) {
      state.root.innerHTML = '<!-- salus scent discovery host -->';
    }
  }

  function render() {
    if (!state.catalog) return;
    syncHost();
    injectTriggers();
    if (state.open) {
      var guard = state._openGuardUntil && Date.now() < state._openGuardUntil;
      var avail = availableSlots();
      // Only close for durable Natural (checked radio) or truly unavailable active slot.
      // Do not close on transient KO getValue flicker of isCustomize().
      var naturalDurable = isNaturalRadioChecked();
      if (!guard && (naturalDurable || avail.indexOf(state.activeSlot) === -1)) {
        closeModal();
      } else if (!state.detailOpen && !state.strengthOpen) {
        renderModalContent();
      }
    }
  }

  function parseCatalog() {
    var el = document.getElementById('salus-scent-discovery-catalog');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent || '{}');
      if (!data || typeof data !== 'object') return null;
      data.categories = Array.isArray(data.categories) ? data.categories.slice() : [];
      data.categories.sort(function (a, b) {
        return (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0);
      });
      data.scents = Array.isArray(data.scents) ? data.scents : [];
      return data;
    } catch (e) {
      return null;
    }
  }

  function observeKeystone() {
    var block = document.getElementById('key_options_block');
    if (!block) return;
    if (state.observer) {
      try { state.observer.disconnect(); } catch (e) {}
    }
    var t = null;
    function schedule() {
      if (t) clearTimeout(t);
      t = setTimeout(function () { render(); }, 120);
    }
    state.observer = new MutationObserver(function (mutations) {
      var skip = true;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes') {
          var tEl = m.target;
          if (tEl && tEl.getAttribute && (
            tEl.getAttribute(WRAP_ATTR) != null ||
            tEl.getAttribute(BTN_ATTR) != null ||
            tEl.getAttribute(SLOT_UI_ATTR) != null ||
            tEl.getAttribute(EDIT_ATTR) != null
          )) continue;
          if (tEl && tEl.classList && (
            tEl.classList.contains('salus-sd__select-row') ||
            tEl.classList.contains('salus-sd__slot-ui') ||
            tEl.classList.contains(KS_CHROME_HIDE)
          )) continue;
          skip = false;
          break;
        }
        var nodes = [];
        if (m.addedNodes) for (var a = 0; a < m.addedNodes.length; a++) nodes.push(m.addedNodes[a]);
        if (m.removedNodes) for (var r = 0; r < m.removedNodes.length; r++) nodes.push(m.removedNodes[r]);
        for (var n = 0; n < nodes.length; n++) {
          var node = nodes[n];
          if (!node || node.nodeType !== 1) { skip = false; break; }
          if (node.getAttribute && (
            node.getAttribute(WRAP_ATTR) != null ||
            node.getAttribute(SLOT_UI_ATTR) != null ||
            (node.querySelector && (node.querySelector('[' + WRAP_ATTR + ']') || node.querySelector('[' + SLOT_UI_ATTR + ']')))
          )) {
            continue;
          }
          skip = false;
          break;
        }
        if (!skip) break;
      }
      if (!skip) schedule();
    });
    state.observer.observe(block, { childList: true, subtree: true, attributes: true, characterData: false });
    block.addEventListener('change', schedule, true);
    block.addEventListener('input', schedule, true);
    var KO = getKO();
    if (KO && typeof KO.on === 'function') {
      try { KO.on('key:options:change', schedule); } catch (e2) {}
      try { KO.on('change', schedule); } catch (e3) {}
    }
  }

  function mount() {
    var root = document.querySelector('[data-salus-scent-discovery]') || document.getElementById('salus-scent-discovery');
    if (!root) return;
    state.root = root;
    state.catalog = parseCatalog();
    bindAtcGuard();
    if (!state.catalog || shouldForceFallback()) {
      // Fallback: do not hide Keystone originals when Discovery cannot initialize
      // or when session-local QA forces fallback.
      state._enhancedReady = false;
      restoreKeystoneChrome();
      removeAllSlotUis(document.getElementById('key_options_block'));
      root.hidden = true;
      if (state.catalog) {
        // Catalog present but forced fallback — still observe so remount can recover.
        ensureModal();
        observeKeystone();
        render();
      }
      return;
    }
    // KeyOptions may load slightly after catalog; still enhance when block/catalog present.
    // If KeyOptions/block never appear, injectSlotControls simply won't find selects (no hide).
    state._enhancedReady = true;
    ensureModal();
    bindValidationRedirect();
    bindProductFormSubmitGuard();
    render();
    observeKeystone();
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (shouldForceFallback()) {
        enterFallbackMode({ focus: false });
        clearInterval(timer);
        return;
      }
      render();
      if (tries >= 20) clearInterval(timer);
    }, 500);
  }

  window.SalusScentDiscovery = {
    KS_SCENT: KS_SCENT,
    KS_STRENGTH: KS_STRENGTH,
    KS_ADD: KS_ADD,
    KS_SCENTING: KS_SCENTING,
    PAGE_SIZE: PAGE_SIZE,
    STRENGTH_OPTIONS: STRENGTH_OPTIONS,
    getValidKeystoneValues: getValidKeystoneValues,
    availableSlots: availableSlots,
    isCustomize: isCustomize,
    selectScent: selectScent,
    confirmPending: confirmPending,
    openStrengthView: openStrengthView,
    closeStrengthView: closeStrengthView,
    changeScentFromStrength: changeScentFromStrength,
    openEditModal: openEditModal,
    setActiveSlot: function (n) { state.activeSlot = Number(n) || 1; if (state.open && !state.detailOpen && !state.strengthOpen) renderModalContent(); },
    getActiveSlot: function () { return state.activeSlot; },
    getCatalog: function () { return state.catalog; },
    refresh: render,
    openModal: openModal,
    closeModal: closeModal,
    openLearnMore: openDetail,
    closeLearnMore: closeDetail,
    parseDescription: parseDescription,
    restoreKeystoneChrome: function () {
      // Public remount path: leave fallback and show exactly one enhanced interface
      // when Discovery can initialize and force-fallback is off.
      if (shouldForceFallback()) {
        enterFallbackMode({ focus: true });
        return;
      }
      if (state.catalog) {
        remountEnhancedMode();
        return;
      }
      restoreKeystoneChrome();
    },
    forceShowKeystoneChrome: function () {
      enterFallbackMode({ focus: true });
      injectSlotControls();
    },
    validateCustomizeForAtc: validateCustomizeForAtc,
    strengthShortLabel: strengthShortLabel,
    _state: state
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
